// extracted by mini-css-extract-plugin
export default {"menu":"Header_menu__kj7yF","logo-link":"Header_logo-link__uTfpP","headerLogo":"Header_headerLogo__v79oy"};